
import React from 'react';
import {
	ColorPicker,
	FormGroup,
	Input,
	FormControl,
	Dropdown,
	CustomText,
    RichEditor,
    Icon,
    ButtonSelect,
} from 'components';
import { ANNOUNCEMENT_POSITIONS } from 'lib/globals'
import styles from 'styles/cart_screen.module.scss';


const AnnouncementSettings = ({shopContext }) => {
    return (
        <FormGroup 
            label="Announcement Banner" 
            info="Get your message across with banner." fullWidth
        >
             <FormControl
                label="Position in Cart Drawer"
                withSwitch={[shopContext, "settings.announcement.isActive"]}
            >
                <Dropdown
                    options={ANNOUNCEMENT_POSITIONS}
                    first
                    BindToContext={[shopContext, "settings.announcement.position"]}
                />
            </FormControl>
            <FormControl >
                <CustomText
                    context={shopContext}
                    label="Customize"
                    path="settings.announcement.text"
                    hasColor={true}
                />
            </FormControl>
            <FormControl >
                <ColorPicker text="Background" BindToContext={[shopContext, 'settings.announcement.background']} />
                <ColorPicker text="Border" BindToContext={[shopContext, 'settings.announcement.border']} />
            </FormControl>
            
            <FormControl label="Style" >
                <Dropdown
                    options={[
                        { value: 'left', label: 'Left' },
                        { value: 'center', label: 'Center' },
                        { value: 'right', label: 'Right' },
                    ]}
                    first
                    BindToContext={[ shopContext, 'settings.announcement.textAlignement']}
                />
            </FormControl>

            <FormControl >
                <ButtonSelect
                    options={[
                        {
                            value: 'rounded',
                            label: "Rounded",
                        },
                        {
                            value: 'full',
                            label: "Full width",
                        },
                    ]}
                    showSeparator={true}
                    BindToContext={[shopContext, 'settings.announcement.style']}
                />
            </FormControl>
        </FormGroup>
    )

}

export default AnnouncementSettings